import React, { useEffect, useState } from 'react'
import { motion, AnimatePresence } from "framer-motion";
import Icon from 'antd/lib/icon'
import SearchInput from './SearchInput'
import { useHistory } from 'react-router-dom'

const Search = () => {

    const history = useHistory()

    const [showInput, setShowInput] = useState(false)

    const onClick = (item) => {
        history.push(`/admin/user/${item.occupancyD2}`)
    }

    return (
        <div style={{ display: 'block', justifyContent: 'end' }}>
              <Icon
                onClick={() => setShowInput(!showInput)}
                type={showInput ? "close" : "search"}
                style={{
                    color: 'white',
                    fontSize: '25px',
                    float: 'right',
                    marginTop: 20,
                    marginLeft: 10,
                    marginRight: 10
                }}
            />
            {showInput && (
                <AnimatePresence>
                    {showInput && (
                        <motion.div
                            initial={{ opacity: 0, x: 100 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0 }}
                        >
                            <div style={{width: 200, float: 'right', display: 'block'}}>
                                <SearchInput visible={showInput} onClick={onClick} />
                            </div>

                        </motion.div>
                    )}
                </AnimatePresence>
            )}
        </div>
    )
}

export default Search
